/**
 * 应用路由相关常量
 */

/**
 * 登录路由路径
 */
export const LOGIN_PATH = '/user/login';

/**
 * 注册路由路径
 */
export const REGISTER_PATH = '/user/register';

/**
 * 注册结果路由路径
 */
export const REGISTER_RESULT_PATH = '/user/register-result';

/**
 * 无需认证的路由列表
 * 这些路由在用户未登录时可以访问
 */
export const UNAUTHENTICATED_PATHS = [
  LOGIN_PATH,
  REGISTER_PATH,
  REGISTER_RESULT_PATH,
];

/**
 * 不需要进行初始化用户信息的路由
 */
export const NO_INITIAL_STATE_PATHS = [
  LOGIN_PATH,
  REGISTER_PATH,
  REGISTER_RESULT_PATH,
];
